import { takeLatest, put, call } from 'redux-saga/effects';

import { history } from '@commons';

import { createVendaAnimal, updateVendaAnimal } from '../service';
import {
  CREATE_VENDA_ANIMAL,
  CREATE_VENDA_ANIMAL_PENDING,
  CREATE_VENDA_ANIMAL_SUCCESS,
  CREATE_VENDA_ANIMAL_FAILURE,
  CONFIG_SESSION
} from '@handler';

import { storage } from '@commons/storage';

import { AlertSuccess, AlertError, AlertWarning } from '@components/common/AlertToast'
import { formatDateDDMMYYYY, isDateValidVerifyDateBetween } from '@components/common/format'

function* sagaCreateVendaAnimal(action) {
  yield put({ type: CREATE_VENDA_ANIMAL_PENDING })

  try {
    const anoPecuarioAtivo = JSON.parse(storage.get(CONFIG_SESSION)).anoPecuarioAtivo;
    var dateFrom = anoPecuarioAtivo.dataInicial;
    var dateTo = anoPecuarioAtivo.dataFinal;
    var dateCheck = action.data.data;

    if (!isDateValidVerifyDateBetween(dateFrom, dateTo, dateCheck)) {
      yield put({ type: CREATE_VENDA_ANIMAL_FAILURE, registro: action.data })

      AlertWarning('Data informada fora do período do ano pecuário ativo. Período deve ser entre '
        + formatDateDDMMYYYY(dateFrom) + ' até ' + formatDateDDMMYYYY(dateTo) + '!');
    } else {
      if (!action.data.vendaDup.geraDuplicata) {
        action.data.vendaDup.tipoDuplicata = null;
        action.data.vendaDup.contaGerencial = null;
        action.data.vendaDup.centroCusto = null;
        action.data.vendaDup.historico = '';
        action.data.vendaDup.tipoPagamento = null;
        action.data.vendaDup.contaCaixa = null;
        action.data.vendaDup.contaBanco = null;
        action.data.vendaDup.numeroParcelas = null;
        action.data.parcelas = [];
      } else if (action.data.vendaDup.geraDuplicata) {
        if (action.data.vendaDup.tipoDuplicata === 'A_VISTA') {
          action.data.vendaDup.numeroParcelas = null;
          action.data.parcelas = [];
          if (action.data.vendaDup.movimentaFinanceiro === false) {
            action.data.vendaDup.contaGerencial = null;
            action.data.vendaDup.centroCusto = null;
            action.data.vendaDup.historico = '';
            action.data.vendaDup.tipoPagamento = null;
            action.data.vendaDup.contaCaixa = null;
            action.data.vendaDup.contaBanco = null;
          }
        } else if (action.data.vendaDup.tipoDuplicata === 'PARCELADA' && action.data.vendaDup.movimentaFinanceiro === false) {
          for (var i = 0; i < action.data.parcelas.length; i++) {
            action.data.parcelas[i].contaGerencial = null;
            action.data.parcelas[i].centroCusto = null;
            action.data.parcelas[i].historico = '';
            action.data.parcelas[i].parcelaPaga = false;
            action.data.parcelas[i].tipoPagamento = null;
            action.data.parcelas[i].contaCaixa = null;
            action.data.parcelas[i].contaBanco = null;
          }
        }
      }

      delete action.data.totalDuplicatas;

      if (action.data.id === undefined || action.data.id === null) {
        yield call(createVendaAnimal, {
          ...action.data,
          propriedade: {
            id: JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id
          },
        });
      } else {
        let lancamentosContaReceber = [];
        action.data.lancamentosContaReceber.forEach(element => {
          lancamentosContaReceber = [
            ...lancamentosContaReceber,
            {
              "forJson": "contareceber",
              "id": element.id,
              "valor": element.valor,
              "historico": element.historico,
              "propriedade": { "id": element.propriedade.id },
              "contaGerencial": {
                "id": element.contaGerencial.id,
                "tipoConta": "A"
              }
            }
          ]
        });

        yield call(updateVendaAnimal,
          {
            ...action.data,
            lancamentosContaReceber: lancamentosContaReceber,
            id: action.data.id
          }
        );
      }

      yield put({ type: CREATE_VENDA_ANIMAL_SUCCESS, registro: action.data })

      history.push('/pecuaria/movimentacao/venda');

      AlertSuccess('Venda registrada com sucesso!');
    }
  } catch (error) {
    yield put({ type: CREATE_VENDA_ANIMAL_FAILURE, registro: action.data })

    AlertError('Falha ao salvar a venda! Tente novamente...');
  }
}

export default function* watchCreateVendaAnimal() {
  yield takeLatest(CREATE_VENDA_ANIMAL, sagaCreateVendaAnimal)
}
